"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterProvider = void 0;
exports.useFilter = useFilter;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : filterContext.js
* Description : Ce fichier contient des données d'enregistrement de filtrage par page pour les recharger lors du retour 
*               sur la page.
* Date de création : 3 juillet 2026
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ // None
/* Hook */
var FilterContext = /*#__PURE__*/(0, _react.createContext)(null);
function useFilter() {
  return (0, _react.useContext)(FilterContext);
}
var FilterProvider = exports.FilterProvider = function FilterProvider(_ref) {
  var children = _ref.children;
  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    targetFilter = _useState2[0],
    setTargetFilter = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    treatmentFilter = _useState4[0],
    setTreatmentFilter = _useState4[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterContext.Provider, {
    value: {
      targetFilter: targetFilter,
      setTargetFilter: setTargetFilter,
      treatmentFilter: treatmentFilter,
      setTreatmentFilter: setTreatmentFilter
    },
    children: children
  });
};